var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { DialogContent, DialogFooter, Alert, Box, Typography } from '@pocketlaw/tetris';
import { useHistory } from 'react-router-dom';
import { object, string } from 'yup';
import { useCloneFreeTextDocument } from 'shared/domains/documents';
import { CancelButton, FormDialog, SubmitButton, TextField } from 'shared/domains/forms';
import { DuplicateDialogHeader } from '../DuplicateDialogHeader';
export function DuplicateFreeTextDialog(props) {
    const { documentId, documentName, onClose } = props;
    const [cloneFreeTextDocument, { error }] = useCloneFreeTextDocument();
    const history = useHistory();
    const initialValues = {
        name: `${documentName} (Copy)`,
    };
    const schema = object().shape({
        name: string()
            .trim()
            .required(t({ comment: 'Copy document dialog - Name is required', message: 'Name is required' })),
    });
    const handleSubmit = (values) => __awaiter(this, void 0, void 0, function* () {
        const { name } = values;
        yield cloneFreeTextDocument({ id: documentId, name }).then((response) => {
            if (response.data) {
                history.push(`/document/${response.data.cloneFromFileSystemDocument.id}`);
            }
        });
    });
    return (<FormDialog size="md" initialValues={initialValues} validationSchema={schema} onClose={onClose} onSubmit={handleSubmit}>
      <DuplicateDialogHeader testId="duplicate-freetext"/>
      <DialogContent>
        <Box flexDirection="column" gap="lg">
          <Typography>
            <Trans comment="Duplicate document dialog - Create a copy of the document">
              What do you want your copy of <b>{documentName}</b> to be named?
            </Trans>
          </Typography>
          <TextField stretch name="name" label={t({ message: `The copy's name`, comment: 'Copy document dialog - New name input label' })} placeholder={t({
            message: `The copy's name...`,
            comment: 'Copy document dialog - New name input placeholder',
        })}/>
          {error && (<Alert appearance="danger" message={t({
                message: 'Something went wrong, please try again later',
                comment: 'Error alert message',
            })}/>)}
        </Box>
      </DialogContent>
      <DialogFooter>
        <CancelButton size="small" appearance="secondary" onClick={onClose}>
          <Trans comment="Copy document dialog - Cancel button label">Cancel</Trans>
        </CancelButton>
        <SubmitButton size="small" appearance="primary">
          <Trans comment="Copy document dialog - Copy button label">Copy document</Trans>
        </SubmitButton>
      </DialogFooter>
    </FormDialog>);
}
